import { FC } from 'react';
import { Tile } from '@carbon/react';
import { format0 } from 'utils/number';
import type { DivisionOrderStatistics } from './types';
import styles from './summary-cards.module.scss';

interface Props {
  statistics: DivisionOrderStatistics | undefined;
}

interface TileSpec {
  label: string;
  value: number | undefined;
}

const fmt = (n: number | undefined): string => format0(n);

const DivisionOrdersSummaryCards: FC<Props> = ({ statistics }) => {
  const tiles: TileSpec[] = [
    { label: 'Total Division Orders', value: statistics?.totalRecords },
    { label: 'Created in Last 24hrs', value: statistics?.last24Hours },
    { label: 'Created in Last 7 Days', value: statistics?.last7Days },
    { label: 'Created in Last Month', value: statistics?.last30Days },
  ];

  return (
    <div className={styles.summary}>
      {tiles.map((t) => (
        <Tile key={t.label} className={styles.tile}>
          <p className={styles.label}>{t.label}</p>
          <p className={styles.value}>{fmt(t.value)}</p>
        </Tile>
      ))}
    </div>
  );
};

export { DivisionOrdersSummaryCards };
